import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { AucFooterModule } from "@auction-ui/footer/footer.module";
import { AucRootAuthnComponent } from "@auction-ui/root/authn/root.authn.component";
import { AucRootService } from "@auction-ui/root/authn/root.authn.service";
import { MfAuthModule, MfFooterModule, MfIconModule, MfRootModule, MfUserPersonaModule } from "@pattonair/material-framework";


@NgModule({
  declarations: [
    AucRootAuthnComponent
  ],
  exports: [
    AucRootAuthnComponent
  ],
  imports: [
    BrowserModule,
    MfRootModule,
    MfAuthModule,
    MfUserPersonaModule,
    MfIconModule,
    MfFooterModule,
    MatButtonModule,
    AucFooterModule,
    RouterModule,
  ],
  providers: [
    AucRootService,
  ]
})
export class AucRootAuthnModule {
}